import React, { useLayoutEffect, useRef,  } from 'react';
import Message, {
  MessageProps,
  PromptRecommendationExample,
  Thinking,
} from '@/pages/datalab/pages/BehaviorAnalysis/GptAnalysis/Chat/components/Message';
import { isEmpty } from 'lodash-es';
import { useNextAskPromptExample } from '../../hooks';

export default function MessageContainer(props) {
  const {
    messages = [], // 所有的聊天消息
    showThinking = true, // 是否显示等待机器回复提示语
    thinkingContent = '',
    handleOnChangText,
  } = props;
  const messageWrapRef = useRef<HTMLDivElement | null>(null);
  const messageContainerRef = useRef<HTMLDivElement | null>(null);
  const { data = [] } = useNextAskPromptExample();
  useLayoutEffect(() => {
    // 新增用户的问题消息时, 自动滚动
    messages?.[messages?.length - 1]?.position === 'right' &&
      messageWrapRef.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'end',
      });
  }, [messages.length]);
 
  useLayoutEffect(() => {
    /**
     * 当新增消息流式输出的过程中, 自动滚动, 避免消息被遮挡.
     * (因为不想多次穿创建销毁 ResizeObserver实例, 所以没有和 scrollIntoView 方式合并到一个useLayoutEffect中)
     */
    let preScrollHeight = 0;
    const resizeObserver = new ResizeObserver((entries) => {
      // @ts-ignore
      const { offsetHeight, scrollTop, scrollHeight } =
        messageContainerRef.current;
      const showHeight = scrollTop + offsetHeight;

      if (preScrollHeight - showHeight < 120) {
        // @ts-ignore
        messageContainerRef.current.scrollTop =
          scrollTop + (scrollHeight - preScrollHeight);
      }
      preScrollHeight = scrollHeight;
    });
    resizeObserver.observe(messageWrapRef.current as HTMLDivElement);
    return () => {
      resizeObserver.unobserve(messageWrapRef.current as HTMLDivElement);
    };
  }, []);
  const onElementRender = <B extends boolean>(props: B) => {
    // 当element组件渲染时，这里的代码会被执行,传递一个函数下去，会导致，element组件将会被除element之外的组件感知到是否被渲染了
  };
  return (
    <div className={'message-container'} ref={messageContainerRef}>
      <div
        className={`message-wrap ${
          messages?.length > 0 ? '' : 'message-empty'
        }`}
        ref={messageWrapRef}
      >
        {messages.map((msg: MessageProps, index: number) => (
          <Message key={index} {...{ ...msg, onElementRender, showThinking }} />
        ))}
        {!isEmpty(messages) && !showThinking && ['end', 'complete'].includes(messages?.[messages?.length - 1]?.status) && <PromptRecommendationExample list={data} handleOnChangText={handleOnChangText} />}
        {showThinking && <Thinking content={thinkingContent} />}
      </div>
    </div>
  );
}
